import { crmApiFetch } from "../../services/crmApi";

export async function createContact(contactData) {
	const response = await crmApiFetch(`/api/contacts`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			account_id: contactData.accountId || undefined,
			email: contactData.email,
			first_name: contactData.firstName,
			last_name: contactData.lastName,
			account: contactData.account,
			primary_problem: contactData.primaryProblem,
			job_title: contactData.jobTitle,
			mobile: contactData.mobile,
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to create contact");
	}

	return payload.contact;
}

export async function getContacts() {
	const response = await crmApiFetch(`/api/contacts`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch contacts");
	}

	return payload.contacts || [];
}


export async function previewContactImport(contactsFile) {
	const formData = new FormData();
	formData.append("contacts_file", contactsFile);

	const response = await crmApiFetch(`/api/contacts/import/preview`, {
		method: "POST",
		body: formData,
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to read import file");
	}

	return {
		headers: payload.headers || [],
		rowCount: payload.row_count || 0,
		maxRows: payload.max_rows || 200,
		previewRows: payload.preview_rows || [],
		suggestedMapping: payload.suggested_mapping || {},
	};
}

export async function importContacts({ contactsFile, columnMapping }) {
	const formData = new FormData();
	formData.append("contacts_file", contactsFile);
	formData.append("column_mapping", JSON.stringify(columnMapping || {}));

	const response = await crmApiFetch(`/api/contacts/import`, {
		method: "POST",
		body: formData,
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to import contacts");
	}

	return {
		imported: payload.imported || 0,
		skipped: payload.skipped || 0,
		failed: payload.failed || 0,
		errors: payload.errors || [],
	};
}

export async function getDeals() {
	const response = await crmApiFetch(`/api/deals`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch deals");
	}

	return payload.deals || [];
}

export async function createDeal(dealData) {
	const response = await crmApiFetch(`/api/deals`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			contact_id: dealData.contactId || undefined,
			account_id: dealData.accountId || undefined,
			deal_type: dealData.dealType,
			deal_name: dealData.dealName,
			acquisition_source: dealData.acquisitionSource,
			primary_offer: dealData.primaryOffer,
			currency: dealData.currency,
			deal_value: dealData.dealValue === "" || dealData.dealValue == null ? undefined : Number(dealData.dealValue),
			deal_stage: dealData.dealStage,
			lost_reason: dealData.lostReason || undefined,
			product_id: dealData.productId === "" || dealData.productId == null ? undefined : Number(dealData.productId),
			description_override: dealData.descriptionOverride || undefined,
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to create deal");
	}

	return payload.deal;
}

export async function updateDealStage(dealId, stage, lostReason = "") {
	const response = await crmApiFetch(`/api/deals/${dealId}/stage`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ stage, lost_reason: lostReason || undefined }),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update deal stage");
	}

	return payload.deal;
}

export async function getDealProducts(dealId) {
	const response = await crmApiFetch(`/api/deals/${dealId}/products`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch deal products");
	}

	return payload.products || [];
}

export async function addDealProduct(dealId, data) {
	const response = await crmApiFetch(`/api/deals/${dealId}/products`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			product_id: data.productId,
			description_override: data.descriptionOverride || "",
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to add product to deal");
	}

	return payload.product;
}

export async function deleteDealProduct(dealId, dealProductId) {
	console.debug("deleteDealProduct request", { dealId, dealProductId });
	const response = await crmApiFetch(`/api/deals/${dealId}/products/${dealProductId}`, {
		method: "DELETE",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		console.error("deleteDealProduct failed", {
			dealId,
			dealProductId,
			status: response.status,
			payload,
		});
		throw new Error(payload.error || "Failed to remove product from deal");
	}

	return payload;
}

export async function getDealByID(dealId) {
	const response = await crmApiFetch(`/api/deals/${dealId}`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch deal");
	}

	return payload.deal;
}

export async function updateDeal(dealId, data) {
	const response = await crmApiFetch(`/api/deals/${dealId}`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update deal");
	}

	return payload.deal;
}

export async function deleteDeal(dealId) {
	const response = await crmApiFetch(`/api/deals/${dealId}`, {
		method: "DELETE",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to delete deal");
	}

	return payload;
}

export async function getContactByID(contactId) {
	const response = await crmApiFetch(`/api/contacts/${contactId}`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch contact");
	}

	return payload.contact;
}

async function getStageHistory(path) {
	const response = await crmApiFetch(path, { method: "GET" });
	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}
	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch stage history");
	}
	return payload.stage_history || [];
}

export function getContactStageHistory(contactId) {
	return getStageHistory(`/api/contacts/${contactId}/stage-history`);
}

export function getDealStageHistory(dealId) {
	return getStageHistory(`/api/deals/${dealId}/stage-history`);
}

export async function updateContact(contactId, contactData) {
	const response = await crmApiFetch(`/api/contacts/${contactId}`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			account_id: contactData.accountId || undefined,
			email: contactData.email,
			first_name: contactData.firstName,
			last_name: contactData.lastName,
			job_title: contactData.jobTitle,
			phone: contactData.phone,
			mobile: contactData.mobile,
			company: contactData.company,
			account: contactData.account,
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update contact");
	}

	return payload.contact;
}

export async function getContactNotes(contactId) {
	const response = await crmApiFetch(`/api/contacts/${contactId}/notes`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch contact notes");
	}

	return payload.notes || [];
}

export async function createContactNote(contactId, content) {
	const response = await crmApiFetch(`/api/contacts/${contactId}/notes`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({ content }),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to create contact note");
	}

	return payload.note;
}

export async function updatePhoneCall(callId, callData) {
	const response = await crmApiFetch(`/api/phone-calls/${callId}`, {
		method: "PATCH",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(callData || {}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update phone call");
	}

	return payload.call || payload.phone_call || payload;
}

export async function getFollowUps({ contactId } = {}) {
	const params = new URLSearchParams();
	if (contactId) {
		params.set("contact_id", String(contactId));
	}

	const queryString = params.toString();
	const response = await crmApiFetch(`/api/follow-ups${queryString ? `?${queryString}` : ""}`, {
		method: "GET",
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to fetch follow ups");
	}

	return payload.follow_ups || [];
}

export async function createFollowUp(followUpData) {
	const response = await crmApiFetch(`/api/follow-ups`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			contact_id: Number(followUpData.contactId),
			method: followUpData.method,
			follow_up_date: followUpData.followUpDate,
			follow_up_time: followUpData.followUpTime,
			next_step: followUpData.nextStep,
			notes: followUpData.notes || "",
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to create follow up");
	}

	return payload.follow_up;
}

export async function updateFollowUp(followUpId, followUpData) {
	const response = await crmApiFetch(`/api/follow-ups/${followUpId}`, {
		method: "PATCH",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			method: followUpData.method || undefined,
			follow_up_date: followUpData.followUpDate || undefined,
			follow_up_time: followUpData.followUpTime || undefined,
			next_step: followUpData.nextStep || undefined,
			notes: followUpData.notes !== undefined ? followUpData.notes : undefined,
		}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update follow up");
	}

	return payload.follow_up;
}

export async function completeFollowUp(followUpId) {
	const response = await crmApiFetch(`/api/follow-ups/${followUpId}/complete`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || "Failed to update follow up");
	}

	return payload.follow_up;
}

